<template>
<div class="login">
  
  <!-- NAV -->
  <div class="nav-wrap">
      <!-- LOGGED IN -->
      <p v-if="userinfo" class="title">Email:&nbsp;<span class="button-text" @click="toggleLogin">{{ userinfo.email }}</span></p>
      <!-- <p class="title" v-if="!userinfo && !showSignUp">Login</p> -->

      <!-- LOGIN -->
      <div v-if="!userinfo && !$store.state.showSignUp">
        <p class="title">
          <span class="button-text" @click="showSignUp('join')">Join</span>
          <span>&nbsp;/&nbsp;</span>
          <span class="button-text active-color striketext" @click="showSignUp('login')">Login</span>
        </p>
      </div>

      <!-- REGISTER -->
      <div v-if="!userinfo && $store.state.showSignUp">
        <p class="title">
            <span class="button-text active-color striketext" @click="showSignUp('join')">Join</span>
            <span>&nbsp;/&nbsp;</span>
            <span class="button-text" @click="showSignUp('login')">Login</span>
          </p>
      </div>

      <!-- CANCEL -->
      <div class="close" @click="toggleLogin">
        <IconCancel class="icon-cancel" />
      </div>
  </div>


  <!-- CONTENT -->
  <div class="content-wrap">

      <!-- LOGGED IN -->
      <form class="form" v-if="userinfo" @submit.prevent="updateProfile()" autocomplete="off">
          <div class="name-input">
            <p class="minor">First name</p>
            <input id="firstname" name="firstname" type="text" v-if="userinfo.firstname" :placeholder="userinfo.firstname" v-model="firstname" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute('readonly');"/>
            <input id="firstname" name="firstname" type="text" v-if="!userinfo.firstname" placeholder="First name" v-model="firstname" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute('readonly');"/>
          </div>
          <div class="name-input">
            <p class="minor">Last name</p>
            <input id="lastname" name="lastname" type="text" v-if="userinfo.lastname" :placeholder="userinfo.lastname" v-model="lastname" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute('readonly');"/>
            <input id="lastname" name="lastname" type="text" v-if="!userinfo.lastname" placeholder="Last name" v-model="lastname" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute('readonly');"/>
          </div>
          <button class="button" type="submit">Update Name</button>
      </form>

      <div v-if="userinfo">
        <button class="button" @click="signOut">Sign Out</button>
        <button class="button" @click="showDeleteUserModal = true">Delete Account</button>
      </div>
      <div v-if="userinfo">
            <div class="deleteUserModal" v-show="showDeleteUserModal">
                <h3>Are you sure you want to DELETE this account?</h3>
                <small>{{ userinfo.email }}</small>
                <small>{{ userinfo.firstname + ' ' + userinfo.lastname }}</small>
                <button class="button" @click="deleteUser()">YES, delete this user</button>
                <button class="button" @click="showDeleteUserModal = false">NO, cancel</button>
            </div>
      </div>

      <!-- JOIN / LOGIN -->
      <form class="form" v-if="!userinfo" @submit.prevent="joinOrLoginSubmit()" autocomplete="off">
          <div class="name-input">
            <p class="minor">Email</p>
            <input id="email" name="email" type="email" placeholder="Email" v-model="email" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute('readonly');"/>
          </div>
          <div class="name-input">
            <p class="minor">Password</p>
            <input id="password" name="password" type="password" placeholder="Password" v-model="password" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute('readonly');"/>
          </div>

      <!-- REGISTER -->          
          <div class="name-input" v-if="$store.state.showSignUp">
            <p class="minor">Confirm Password</p>
            <input type="password" placeholder="Confirm Password" v-model="confPassword"/>
          </div>
          <div class="name-input" v-if="$store.state.showSignUp">
            <p class="minor">First Name</p>
            <input type="text" placeholder="First name" v-model="firstname"/>
          </div>
          <div class="name-input" v-if="$store.state.showSignUp">
            <p class="minor">Last Name</p>
            <input type="text" placeholder="Last name" v-model="lastname"/>
          </div>

      <!-- BUTTONS -->
      <!-- LOGIN -->
          <div class="buttons-row" v-if="!$store.state.showSignUp">
            <p class="terms-check minor">
              <span>Don't have an account?&nbsp;</span>
              <span class="button-text" @click="showSignUp('join')">Sign up here!</span>
            </p>
            <button class="button" type="submit">Login</button>
          </div>
      <!-- REGISTER -->
          <div class="buttons-row" v-if="$store.state.showSignUp">
            <p class="terms-check minor">
              <span>By signing up, you agree to our&nbsp;</span>
              <span class="button-text" @click="toggleLegal('terms')">Terms of Use</span>
            </p>
            <button class="button" type="submit">Join</button>
          </div>
      </form>

      <!-- Errors -->
      <p v-if="errors.length"><b>Error(s):</b><ul><li v-for="error in errors" :key="error.key">{{ error }}</li></ul></p>
        
  </div>

</div>
</template>

<script>
import { db, auth } from '../db'
import IconCancel from '../assets/icons/IconCancel.vue'

export default {
  name: 'Login',
  props: [
    "userinfo"
  ],
  components: {
    IconCancel
  },
  data() {
    return {
      email: '',
      password: '',
      username: '',
      firstname: '',
      lastname: '',
      confPassword: '',
      errors: [],
      showDeleteUserModal: false,
    }
  },
  methods: {
    joinOrLoginSubmit() {
      if (this.$store.state.showSignUp) {
        return this.signUp()
      } else {
        return this.signIn()
      }
    },
    toggleCreatePost() {
      this.$store.commit('toggleCreatePost')
    },
    toggleLogin(payload) {
      this.$store.commit('toggleLogin', payload)
    },
    showSignUp(payload) {
      this.$store.commit('showSignUp', payload)
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
    toggleLegal(payload) {
      this.$store.commit('toggleLegal', payload)
    },

    signIn() {
      auth.signInWithEmailAndPassword(this.email, this.password)
      .then(() => {
          console.log(`Logged in`)
          this.$store.commit('togglePopMess', 'Hey you, welcome!')
          this.errors = []
      }).catch(err => {
          console.log(err.message)
          this.errors.push(err.message)
        })
    },
    signUp() {
      if(this.password == this.confPassword) {
        auth.createUserWithEmailAndPassword(this.email, this.password)
        .then(e => {
            return db.collection('users').doc(e.user.uid).set({
              uid: e.user.uid,
              firstname: this.firstname,
              lastname: this.lastname,
              actions: {'test': 1}, //Om jag inte har ett object med fält här så spottar den inte ut några poster pga findUserPostActions i Post.vue
              email: e.user.email,
              pic: ''
            })
            // Update profile gick bara att köra separat, men det är ändå bra för att den kommer behöva kallas separat när man behöver uppdatera nåt ändå
            // return this.updateProfile()
        })
        .then(() => {
          console.log('Account created')
          this.showSignUp = false
          this.$router.go()
          this.errors = []
        })
        .catch(err => {
          console.log(err.message)
          this.errors.push(err.message)
          })
      } else {
        this.errors.push('Password does not match')
      }
    },
    signOut() {
      auth.signOut()
        .then(() => {
            console.log(`Signed out`)
            this.$router.go()
            this.$store.commit('togglePopMess', 'Bye bye!')
        }).catch(err => {console.log(err.message)})
    },
    updateProfile() {
      if (this.firstname && this.lastname) {
        db.collection('users').doc(auth.currentUser.uid)
        .set({
            firstname: this.firstname,
            lastname: this.lastname,
        },{merge:true})
        .then(() => {
          console.log('Profile updated')
          this.$store.commit('toggleLogin')
          this.$store.commit('togglePopMess', 'Profile updated!')
          this.errors = []
        }).catch(err => {console.log(err.message)})
      } else {
        this.errors.push('One field empty')
      }
    },
    deleteUser() {
      const authUser = auth.currentUser
      const docRef = db.collection('users').doc(authUser.uid)
        docRef.delete().then(()=> {
          console.log('Doc deleted')
          authUser.delete().then(()=> {
            console.log('User deleted')
            this.$router.go()
            this.$store.commit('togglePopMess', 'User deleted!')
          }).catch(err => {
            console.log(err.message)
            this.errors.push(err.message)
        })
      }).catch(err => {
        console.log(err.message)
        this.errors.push(err.message)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.login {
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  background-color: $white;
  border-left: $line-bold solid $line-color-dark;
  right: 0;
  // width: calc(#{$col6} + #{$grid-padding});
  width: 50%;
  z-index: 40;
  .nav-wrap {
    position: fixed;
    right: 0;
    background-color: white;
    // width: calc(#{$col6} + #{$grid-padding});
    width: 50vw;
    height: $nav-height;
    border-bottom: $line-bold solid $line-color-dark;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .title {
      margin-left: $main-margin;
      display: flex;
    }
    .close {
      position: fixed;
      right: 0;
      margin-right: $main-margin;
      display: flex;
      align-items: center;
      .icon-cancel {
        padding: 0;
      }
    }
  }
  .content-wrap {
    margin: $nav-height $grid-padding $nav-height $main-margin;
    .deleteUserModal {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: $icon-hover-color;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .button, h3 {
        width: 80%;
        margin-top: 20px;
      }
      p {
        color: $black;
      }
    }
    .names {
      display: flex;
      justify-content: space-between;
      .name-input {
        width: 100%;
        &:nth-child(2) {
          margin-left: $main-margin;
        }
      }
    }
    .buttons-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .button {
        width: calc(50% - (#{$main-margin} / 2));
      }
      .terms-check {
        display: inline-block;
        // flex-direction: column;
        // justify-content: center;
        // height: $nav-height;
        margin-top: 0;
        .button-text {
          white-space: nowrap;
        }
      }
    }
    .button {
      width: 100%;
      height: $nav-height;
      margin-top: calc(#{$main-margin} * 2);
    }
    .button-secondary {
      background-color: transparent;
      margin-top: $main-margin;
      &:hover {
        color: $icon-hover-color;
      }
    }
  }
}

// MOBILE
@media #{$mobile} {    
    .login {
      width: 100%;
      .nav-wrap { 
        width: 100%;
        height: $nav-height-mobile;
        .title {
          margin-left: $main-margin-mobile;
        }
        .close {
          margin-right: $main-margin-mobile;
        }
      }
      .content-wrap {
        margin: $nav-height-mobile $main-margin-mobile;
      }    
    }    
}

</style>